import { FC } from 'react';
import styles from './PageTitle.module.css';
import { ButtonProps, ButtonWidth, ButtonWrapper } from '../Button';

export interface PageTitleProps {
    text: string;
    subText?: string;
    title?: string;
    className?: string;
    iconSource?: string;
    iconSize?: number;
    action?: ButtonProps;
}

export const PageTitle: FC<PageTitleProps> = ({text, subText, title, iconSource, iconSize = 36, action}) => {
    document.title = `${title || text} | ログイン | So-net`;
    return (
        <div className={styles['str-pageTitle']}>
            <div className={styles['inner']}>
                {iconSource && (
                    <span className={styles['symbol']}>
                        <img src={iconSource} alt="" width={iconSize} height={iconSize} />
                    </span>
                )}
                <h1>
                    {subText ? (
                        <>
                            <span>{subText}</span>
                            <strong>{text}</strong>
                        </>
                    ) : (
                        text
                    )}
                </h1>
                {action && <ButtonWrapper {...{buttons: [{...action, width: ButtonWidth.NARROW}]}} />}
            </div>
        </div>
    );
};
